import { ReferralData } from "@nelo/signup-lib"
import React from "react"

import IDVerificationStep from "./steps/IDVerificationStep"
import LoadingStep from "./steps/LoadingStep"
import LoanOptionsStep from "./steps/LoanOptionsStep"
import OrderCompletedSuccessfullyStep from "./steps/OrderCompletedSuccessfullyStep"
import PaymentOptionsPickerStep from "./steps/PaymentOptionsPickerStep"
import RejectedStep from "./steps/RejectedStep"
import SignupNativeStep from "./steps/SignupNativeStep"
import SuccessStep from "./steps/SuccessStep"

export enum StepId {
  PAYMENT_OPTIONS_PICKER = "PAYMENT_OPTIONS_PICKER",
  SIGNUP_NATIVE = "SIGNUP_NATIVE",
  LOADING = "LOADING",
  SUCCESS = "SUCCESS",
  REJECTED = "REJECTED",
  LOAN_OPTIONS = "LOAN_OPTIONS",
  IDENTITY_VERIFICATION_STACK = "IDENTITY_VERIFICATION_STACK",
  SERVER_ERROR = "SERVER_ERROR",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  ORDER_COMPLETED_SUCCESSFULLY = "ORDER_COMPLETED_SUCCESSFULLY",
}

export interface StepProps {
  onComplete: () => void
  onBack: () => void
  initialReferralData: ReferralData
}

export const stepRegistry: Record<string, React.ComponentType<StepProps>> = {
  [StepId.PAYMENT_OPTIONS_PICKER]: PaymentOptionsPickerStep,
  [StepId.SIGNUP_NATIVE]: SignupNativeStep,
  [StepId.LOADING]: LoadingStep,
  [StepId.LOAN_OPTIONS]: LoanOptionsStep,
  [StepId.SUCCESS]: SuccessStep,
  [StepId.REJECTED]: RejectedStep,
  [StepId.IDENTITY_VERIFICATION_STACK]: IDVerificationStep,
  [StepId.ORDER_COMPLETED_SUCCESSFULLY]: OrderCompletedSuccessfullyStep,
}
